import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import { installErrorReporter } from './services/errorReporter';
import reportWebVitals from './reportWebVitals';

// Kullanicinin yasadigi hatalari (API 4xx/5xx, JS hatasi, ekran cokmesi,
// yuklenemeyen sayfa, sinirli tiklama) backend'e bildirir; mail yalniz prod.
installErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
